import styled from 'styled-components';

interface Props {
  formItemFirst?: boolean;
  formItemLast?: boolean;
}

export default styled.section<Props>`
  margin-top: ${({ formItemFirst }) => (formItemFirst ? 48 : 0)}px;
  margin-bottom: ${({ formItemLast }) => (formItemLast ? 48 - 24 : 48)}px;
`;
